import React, { useEffect, useState } from "react";
import { Upload2 } from "../icons";
import { useMediaQuery } from "react-responsive";

export default function BusinessInfoForm({
  onBack,
  onNext,
  onsubmit,
  businessInfoFormData,
  setBusinessInfoFormData,
  handleBusinessInputChange,
  handleOptionSelect,
  handleRemoveOption,
  handleBusinessImageChange,
  handleBusinessInputCheckbox,
}) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!businessInfoFormData.businessName)
      newErrors.businessName = "business name is required.";
    if (!businessInfoFormData.selectedOptions)
      newErrors.selectedOptions = "business Type is required.";
    if (!businessInfoFormData.destinationPort)
      newErrors.destinationPort = "port is required.";
    if (!businessInfoFormData.destinationCountry)
      newErrors.destinationCountry = "Country is required.";
    if (!businessInfoFormData.shippingMethod)
      newErrors.shippingMethod = "shipping method is required.";
    if (!businessInfoFormData.password)
      newErrors.password = "password is requied";
    if (!businessInfoFormData.selectedBusinessImage)
      newErrors.selectedBusinessImage = "upload business card";
    if (!businessInfoFormData.confirmPassword)
      newErrors.confirmPassword = "Confirm Password is required.";

    setErrors(newErrors);

    if (
      businessInfoFormData.password !== businessInfoFormData.confirmPassword
    ) {
      setBusinessInfoFormData({
        ...businessInfoFormData,
        passwordMatchError: true,
      });
      newErrors.passwordMatchError = "Password don't match.";
    } else {
      setBusinessInfoFormData({
        ...businessInfoFormData,
        passwordMatchError: false,
      });
    }
    if (Object.keys(newErrors).length === 0) {
      await onNext();
    }
  };
   useEffect(() => {
    const middleOfPage = window.innerHeight / 2;
    window.scrollTo(0, middleOfPage);
  }, []);

  return (
    <div className="Businessinfo-page">
      <div className="container">
        <p className="heading">Business Information</p>
        <div className="row p-2 justify-content-center inputpadding">
          <div className="col-12 col-md-5 col-lg-6 ">
            <input
              type="text"
              name="businessName"
              placeholder="Business Name"
              className={`border ${
                errors.businessName ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
              value={businessInfoFormData.businessName}
              onChange={handleBusinessInputChange}
            />
            {errors.businessName && (
              <p className="text-danger">{errors.businessName}</p>
            )}
          </div>
          <div className="col-12 col-md-1 col-lg-6 ">
            <div className="form-group ">
              <select
                id="languages"
                name="selectedOptions"
                className="border border-secondary rounded "
                onChange={(e) => handleOptionSelect(e.target.value)}
              >
                <option value="">Business type</option>
                <option value="All type">All type</option>
                <option value="Damage Car">Damage Car</option>
                <option value="Used Car">Used Car</option>
                <option value="Truck">Truck</option>
                <option value="Forklift">Forklift</option>
                <option value="Construction Machinery">
                  Construction Machinery
                </option>
                <option value="Industrial Machinery">
                  Industrial Machinery{" "}
                </option>
                <option value="Form Machinery">Form Machinery</option>
                <option value="Parts">Parts</option>
              </select>
              <div>
                {errors.selectedOptions && (
                  <p className="text-danger">{errors.selectedOptions}</p>
                )}
                {businessInfoFormData.selectedOptions.map((option, index) => {
                  return (
                    <div key={index} className="chip">
                      <span className="chip-text">{option}</span>
                      <button
                        type="button"
                        className="chip-button"
                        onClick={() => handleRemoveOption(index)}
                      >
                        <span
                          role="img"
                          aria-label="Remove"
                          style={{ color: "gray" }}
                        >
                          ✕
                        </span>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2 justify-content-center inputpadding">
          <div className="col-12 col-md-5 col-lg-6">
            <div className="image-upload-container">
              <label htmlFor="image-upload-3" className="upload-label">
                {businessInfoFormData.selectedBusinessImage ? (
                  <img
                    src={businessInfoFormData.selectedBusinessImage}
                    alt="Uploaded"
                    className="uploaded-image-2"
                  />
                ) : (
                  <div className="upload-placeholder">
                    <span>
                      <Upload2 />
                      Upload Business Card
                    </span>
                  </div>
                )}
              </label>

              <input
                name="selectedBusinessImage"
                type="file"
                id="image-upload-3"
                accept="image/*"
                className={` ${
                  errors.selectedBusinessImage
                    ? "border-danger"
                    : "border-secondary"
                }`}
                onChange={handleBusinessImageChange}
              />
            </div>
            {errors.selectedBusinessImage && (
              <p className="text-danger">{errors.selectedBusinessImage}</p>
            )}
          </div>
          <div className="col-12 col-md-1 col-lg-6">
            <select
              className={`border ${
                errors.tradeTerm ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
              name="tradeTerm"
              value={businessInfoFormData.tradeTerm}
              onChange={handleBusinessInputChange}
            >
              <option>Trade Term</option>
              <option value="C&F">C&F</option>
              <option value="C&I">C&I</option>
              <option value="CIF">CIF</option>
            </select>
            {errors.tradeTerm && (
              <p className="text-danger">{errors.tradeTerm}</p>
            )}

            <p>Shipping Method</p>
            <div className=" d-flex justify-content-center p-1">
              <label htmlFor="container">
                <input
                  type="radio"
                  value="container"
                  checked={businessInfoFormData.shippingMethod === 'container'}
                  name="shippingMethod"
                  id="container"
                  onChange={handleBusinessInputChange}
                  className="small-text"
                />{" "}
                <span className="small-text ">Container</span>
              </label>
              <div className="mx-4"></div>
              <label htmlFor="roro">
                <input
                  type="radio"
                  value="roro"
                  name="shippingMethod"
                  checked={businessInfoFormData.shippingMethod === 'roro'}
                  onChange={handleBusinessInputChange}
                  id="roro"
                  className="small-text"
                />{" "}
                <span className="small-text">Roll-Off/Roll-ON</span>
              </label>
            </div>
            {errors.shippingMethod && (
              <p className="text-danger">{errors.shippingMethod}</p>
            )}
          </div>
        </div>
        <div className="row p-2 justify-content-center inputpadding">
          {isMobile ? (
            <>
              <div className="col-12">
                <input
                  type="text"
                  placeholder="Destination Port"
                  className={`border ${
                    errors.port ? "border-danger" : "border-secondary"
                  } rounded mb-2 form-control`}
                  name="destinationPort"
                  value={businessInfoFormData.destinationPort}
                  onChange={handleBusinessInputChange}
                />
                {errors.destinationPort && (
                  <p className="text-danger">{errors.destinationPort}</p>
                )}
              </div>
              <div className="col-12">
                <input
                  type="text"
                  placeholder="Destination Country"
                  className={`border ${
                    errors.country ? "border-danger" : "border-secondary"
                  } rounded mb-2 form-control`}
                  name="destinationCountry"
                  value={businessInfoFormData.destinationCountry}
                  onChange={handleBusinessInputChange}
                />
                {errors.destinationCountry && (
                  <p className="text-danger">{errors.destinationCountry}</p>
                )}
              </div>
            </>
          ) : (
            <>
              <p>Destination</p>
              <div className="col-12 col-md-5 col-lg-6">
                <input
                  type="text"
                  placeholder="Port"
                  className={`border ${
                    errors.destinationPort
                      ? "border-danger"
                      : "border-secondary"
                  } rounded mb-2 form-control`}
                  name="destinationPort"
                  value={businessInfoFormData.destinationPort}
                  onChange={handleBusinessInputChange}
                />
                {errors.destinationPort && (
                  <p className="text-danger">{errors.destinationPort}</p>
                )}
              </div>
              <div className="col-12 col-md-5 col-lg-6">
                <input
                  type="text"
                  placeholder="Country"
                  className={`border ${
                    errors.destinationCountry
                      ? "border-danger"
                      : "border-secondary"
                  } rounded mb-2 form-control`}
                  name="destinationCountry"
                  value={businessInfoFormData.destinationCountry}
                  onChange={handleBusinessInputChange}
                />
                {errors.destinationCountry && (
                  <p className="text-danger">{errors.destinationCountry}</p>
                )}
              </div>
            </>
          )}
        </div>

        <div className="row p-2 justify-content-center inputpadding">
          <div className="col-12 col-md-5 col-lg-6">
            <input
              type="password"
              placeholder="Password"
              className="border border-secondary rounded mb-2 form-control passwordheight"
              name="password"
              value={businessInfoFormData.password}
              onChange={handleBusinessInputChange}
            />
            {errors.password && (
              <p className="text-danger">{errors.password}</p>
            )}
          </div>
          <div className="col-12 col-md-5 col-lg-6">
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              className={`border ${
                errors.confirmPassword ? "border-danger" : "border-secondary"
              } rounded form-control passwordheight`}
              value={businessInfoFormData.confirmPassword}
              onChange={handleBusinessInputChange}
            />
            {errors.passwordMatchError && (
              <p className="text-danger">{errors.passwordMatchError}</p>
            )}
          </div>
        </div>
        <div className="row p-2 justify-content-center inputpadding">
          <div className="col-12 col-md-5 col-lg-12">
            <div className="terms">
              <h5>BTC Terms and Conditions.</h5>
              <p>
                I Agree to these Terms & Conditions.
                <br />
                I Agree to these Terms & Conditions.
                <br />
                I Agree to these Terms & Conditions.
                <br />
                I Agree to these Terms & Conditions.
                <br />
                I Agree to these Terms & Conditions.
                <br />I Agree to these Terms & Conditions.
              </p>
            </div>
          </div>
        </div>
        <div className="row col-12 col-md-10 col-lg-6 p-2 inputpadding">
          <label htmlFor="agreedTerms">
            <input
              type="checkbox"
              value={"agreedTerms"}
              name="agreedTerms"
              checked={businessInfoFormData.agreedTerms === 'agreedTerms'}
              id="agreedTerms"
              onChange={handleBusinessInputCheckbox}
            />{" "}
            <span className="labelstyle">
              I Agree to these Terms and Condition
            </span>
          </label>
          <label htmlFor="receivedpromotion">
            <input
              type="checkbox"
              value={"receivedpromotion"}
              name="receivedpromotion"
              checked={businessInfoFormData.receivedpromotion === 'receivedpromotion'}
              onChange={handleBusinessInputChange}
              id="receivedpromotion"
            />{" "}
            <span className="labelstyle2">Recived BTC Promotinal Email</span>
          </label>
        </div>
        <div className="m-2 d-flex justify-content-center inputpadding">
          <div className="col-4 col-md-4 col-lg-4">
            <button type="button" className="buttonstyle2" onClick={onBack}>
              {"<"}&nbsp; Back
            </button>
          </div>
          <div className="col-8 col-md-4 col-lg-6">
            <button
              type="submit"
              className="buttonstyle3"
              onClick={handleSubmit}
              disabled={!businessInfoFormData.agreedTerms}
            >
              Next &nbsp;{">"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
